import { PacketReference } from '../../models';
import {
  ASPIRATION_LABELS,
  COVER_MEMOS,
  GROWTH,
  GROWTH_STATUS,
  PILLARS,
  POLICIES_BY_ROLE,
  TRAINING_CATALOG,
  TRAINING_STATUS_STYLE,
} from '../prototype/packet-data';

/**
 * Position Packet reference data — mapped from the prototype packet datasets
 * (source of truth). The shapes are already correct; this seed simply binds the
 * verbatim consts to the typed PacketReference contract.
 */
export const PACKET_REFERENCE_SEED: PacketReference = {
  coverMemos: COVER_MEMOS,
  policiesByRole: POLICIES_BY_ROLE,
  pillars: PILLARS,
  trainingCatalog: TRAINING_CATALOG,
  trainingStatusStyle: TRAINING_STATUS_STYLE,
  growth: GROWTH,
  growthStatus: GROWTH_STATUS,
  aspirationLabels: ASPIRATION_LABELS,
};
